var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { initFormValidation, showSubmitError, comparePwd } from './form-validation';
import showHidePwd from './show-hide-pwd';
import fetchData from '../unilities/fetch-data';
const initTrialForm = () => {
    showHidePwd();
    const trialSubmitButtons = document.querySelectorAll('.js-trial-form-submit');
    trialSubmitButtons &&
        trialSubmitButtons.forEach((button) => {
            button.addEventListener('click', (e) => __awaiter(void 0, void 0, void 0, function* () {
                const formContainer = button.closest('.js-trail-form');
                const form = button.closest('.js-form');
                const successMessage = formContainer.querySelector('.js-form-success-message');
                const loader = document.querySelector('.js-form-loader');
                loader && loader.classList.add('show');
                const formIsValid = initFormValidation(form);
                if (formIsValid && comparePwd(form)) {
                    try {
                        const email = form.querySelector('.js-email');
                        const password = form.querySelector('.js-pass-1');
                        const country = form.querySelector('.js-country');
                        const url = `https://betty.acclivitysoftware.com/RerunTrial/RerunTrial?path=rerun_tv&email=${email.value.trim()}&password=${password.value.trim()}&country=${country.value.trim()}`;
                        const resp = yield fetchData(url);
                        if (resp.error === 0 && successMessage) {
                            const trialVersionThankYouPage = var_from_php.trial_version_thank_you_page;
                            if (trialVersionThankYouPage) {
                                window.location.href = trialVersionThankYouPage;
                            }
                            else {
                                form.classList.add('hide');
                                successMessage.innerHTML = resp.message;
                                successMessage.classList.add('show');
                            }
                        }
                        else {
                            showSubmitError(resp.message);
                        }
                        loader && loader.classList.remove('show');
                    }
                    catch (error) {
                        showSubmitError('Something went wrong, please try again later');
                        console.error('Error:', error);
                        loader && loader.classList.remove('show');
                    }
                }
                else {
                    loader && loader.classList.remove('show');
                }
            }));
        });
};
export default initTrialForm;
